/**
 * Created by hao.cheng on 2017/4/22.
 */
import React from 'react';
import { Breadcrumb, Switch, Icon } from 'antd';
import { Link } from 'react-router-dom';
import themes from '../style/theme';

class BreadcrumbCustom extends React.Component {
    state = {
        switcherOn: false,
        theme: null,
        themes: JSON.parse(localStorage.getItem('themes')) || [
            {type: 'info', checked: false},
            {type: 'grey', checked: false},
            {type: 'danger', checked: false},
            {type: 'warn', checked: false},
            {type: 'white', checked: false},
        ],
    };
    componentDidMount() {
        this.state.themes.forEach(val => {
            val.checked && this.setState({
                theme: themes['theme' + val.type] || null
            });
        })
    }
    switcherOn = () => {
        this.setState({
            switcherOn: !this.state.switcherOn
        })
    };
    themeChange = (v) => {
        this.setState({
            themes: this.state.themes.map((t, i) => {
                (t.type === v.type && (t.checked = !t.checked)) || (t.checked = false);
                return t;
            }),
            theme: (v.checked && themes['theme' + v.type]) || null
        }, () => {
            localStorage.setItem('themes', JSON.stringify(this.state.themes));
        })
    };
    render() {
        const themesTag = this.state.themes.map((v, i) => (
            <div className="pull-left y-center mr-m mb-s" key={i}>
                <i className={`w-24 mr-s b-a ${v.type}`} />
                <Switch checked={v.checked} onChange={() => this.themeChange(v)} />
            </div>
        ));
        const first = <Breadcrumb.Item style={{color:"#d2a475"}}>{this.props.first}</Breadcrumb.Item> || '';
        const second = <Breadcrumb.Item>{this.props.second}</Breadcrumb.Item> || '';
        return (
            <span>
                <Breadcrumb style={{ margin: '12px 0',position:"absolute",top:98,left:362}}>
                        {first}
                        {second}
                </Breadcrumb>
            </span>
        )
    }
}

export default BreadcrumbCustom;



// WEBPACK FOOTER //
// ./src/components/BreadcrumbCustom.jsx